/* eslint-disable @typescript-eslint/no-unused-expressions */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { Staff } from '../../types/types';

import { axiosInstance } from '../../helpers/axios';
import { authSlice } from './AuthSlice';
const initialState: StaffState = {
    staff: null,
    isLoading: false,
    error: null,
};

interface StaffState {
    staff: Staff | null;
    isLoading: boolean;
    error: any;
}

//асинхронная позгрузка инфы о пользователе по айди
export const fetchStaffInfo = createAsyncThunk(
    'staff/fetchStaffInfo',
    async function (id: number, { dispatch }) {
        const token = localStorage.getItem('token');
        const url = `/v1/staff/${id}/`;

        const data = await axiosInstance
            .get(url, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((data) => data.data)
            .catch(async (error: AxiosError<{ code: string }>) => {
                if (error.response?.data.code === 'token_not_valid') {
                    const refresh = localStorage.getItem('refresh');
                    const urlRefresh = `/v1/token/refresh/`;

                    await axiosInstance
                        .post<{
                            access: string;
                            refresh: string;
                        }>(urlRefresh, {
                            refresh: refresh,
                        })
                        .then((data) => {
                            if (data.data.access) {
                                dispatch(
                                    authSlice.actions.refreshToken({
                                        token: data.data.access,
                                    }),
                                );
                                localStorage.setItem('token', data.data.access);
                            }
                        });

                    const dataRefresh = await axiosInstance
                        .get(url)
                        .then((data) => data.data);

                    return dataRefresh;
                }
            });

        return data;
    },
);

export const staffSlice = createSlice({
    name: 'staff',
    initialState,
    reducers: {
        clearStaff(state) {
            state.staff = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchStaffInfo.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStaffInfo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.staff = action.payload;
        });
        builder.addCase(fetchStaffInfo.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});

export default staffSlice.reducer;
